import { ColDef } from "ag-grid-community";
import { RowDef } from "../../components/ag-grid-extensions/models/RowDef";
import i18n from "../../services/localization-service/i18n";
import { IDateRange } from "../../common/models/IDateRange";
import { IAlarmAndRecipientsSetpointInformation } from "../../services/admin-report-data-service/Models";
import { DataTypeEnum } from "../../common/enums/DataTypeEnum";

const projectRow = (
    entry: IAlarmAndRecipientsSetpointInformation): RowDef => {

    const row: RowDef = {
    };

    row['setPointName'] = entry.setPointName;
    row['setPointOperator'] = entry.setPointOperator;
    row['setPointValue'] = entry.setPointDataType === DataTypeEnum.Double ? entry.setPointValue.toString() : entry.setPointTextValue;
    row['notifyonAlarm'] = entry.tagAlarmNotify ? "True" : "False";
    row['notifyonNormal'] = entry.tagClearNotify ? "True" : "False"
    row['deviceDisplayName'] = entry.deviceDisplayName;
    row['tagName'] = entry.tagName;
    row['alarmSchemeName'] = entry.alarmSchemeName;
    row['schemeDefinition'] = entry.schemeDefinition;
    row['notificationListName'] = entry.notificationListName;
    row['notificationListRecipientList'] = entry.notificationListRecipientList;
    row['directRecipientList'] = entry.directRecipientList;
    row['userFirstName'] = entry.userFirstName;
    row['userLastName'] = entry.userLastName;


    return row;
}

const AlarmSetpointReportUtils = {

    createGridRows: function (entries: IAlarmAndRecipientsSetpointInformation[] | undefined): RowDef[] {

        const rows: RowDef[] = entries?.map((o) => {
            return projectRow(o);
        }) ?? [];

        return rows;
    },
    createGridColumns: function (): ColDef[] {


        const cols: ColDef[] = [{
            headerName: i18n.t("alarmSetpointReport.setpointName") as string,
            field: 'setPointName',
            sort: 'asc',
            pinned: 'left',
            //minWidth: 300,
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.setpointOperator") as string,
            field: "setPointOperator",
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("alarmSetpointReport.setpointValue") as string,
            field: "setPointValue",
            maxWidth: 148,
            type: "number"
        }, {
            headerName: i18n.t("alarmSetpointReport.notifyonAlarm") as string,
            field: "notifyonAlarm",
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("alarmSetpointReport.notifyonNormal") as string,
            field: "notifyonNormal",
            maxWidth: 148,
            type: "text"
        }, {
            headerName: i18n.t("alarmNotificationReports.device") as string,
            field: "deviceDisplayName",
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.tag") as string,
            field: "tagName",
            type: "text, multiline"
        }, {
            headerName: "Scheme Name",
            field: "alarmSchemeName",
            type: "text"
        }, {
            headerName: i18n.t("alarmSetpointReport.schemeDefinition") as string,
            field: "schemeDefinition",
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.notificationListName") as string,
            field: "notificationListName",
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.notificationListRecipientList") as string,
            field: "notificationListRecipientList",
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.directrecipientlist") as string,
            field: "directRecipientList",
            type: "text, multiline"
        }, {
            headerName: i18n.t("alarmSetpointReport.userFirstName") as string,
            field: "userFirstName",
            type: "text"
        }, {
            headerName: i18n.t("alarmSetpointReport.userLastName") as string,
            field: "userLastName",
            type: "text"
        }];

        return cols;
    },

    getGridNoDataMessage(tagName: string, dateRange?: IDateRange): string {

        let message: string;

        if (dateRange && dateRange.startDate && dateRange.endDate) {
            message = i18n.t("noData.noDataForObjectWithinDateRange", {
                startDate: dateRange.startDate.toLocaleString(),
                endDate: dateRange.endDate.toLocaleString(),
                objectName: tagName
            });

        } else {
            message = i18n.t("noData.noDataForObject", { objectName: tagName });
        }

        return message;
    },
};

export default AlarmSetpointReportUtils;
